<div class="images-grid">
	@for (image of images; track $index) {
		<div class="image-wrapper" (click)="toggleImageSelection(image)" [class.selected]="isImageSelected(image)">
			<img [src]="image.url" alt="{{ image.filename }}" class="image-thumbnail" />
			<div class="selection-overlay" [class.visible]="isImageSelected(image)">
				<div class="check-icon">✓</div>
			</div>
		</div>
	}
</div>
